import { useTranslation } from 'react-i18next';
import { useCreateInvoice } from 'api/invoices/use-create-invoice.ts';
import type { CreateInvoiceReq } from 'api/swagger';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { FormDrawerWithButton } from 'components/common/form-drawer-with-button';
import { InvoiceForm } from 'components/invoices/invoice-form';
import type { IInvoiceFormFields } from 'components/invoices/invoice-form';
import type { IInvoiceCreateProps } from './types';

export const InvoiceCreateComponent = (props: IInvoiceCreateProps) => {
  const { orderId, tripId, whTaskId, isMain = false, initialValues, isLoadingData = false } = props;

  const { t } = useTranslation();
  const { mutateAsync: createInvoice, isLoading: isLoading } = useCreateInvoice();

  const handleFinish = async (values: IInvoiceFormFields) => {
    const apiVariables: CreateInvoiceReq = {
      orderId,
      tripId,
      warehouseTaskId: whTaskId,
      currency: values.currency,
      price: values.price,
      vatPercent: values.vat || 0,
      main: isMain || false,
    };

    await createInvoice(apiVariables);
  };

  return (
    <FormDrawerWithButton
      formComponent={InvoiceForm}
      formProps={{ initialValues }}
      buttonLabel={isMain ? t('invoice:create_main_invoice') : t('invoice:create_additional_invoice')}
      title={isMain ? t('invoice:create_main_invoice') : t('invoice:create_additional_invoice')}
      isLoading={isLoading}
      buttonDisabled={isLoadingData}
      onFinish={handleFinish}
    />
  );
};

export const InvoiceCreate = withRoleGuard<IInvoiceCreateProps>(InvoiceCreateComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
